module.exports = __webpack_public_path__ + "img/Foto_AutoMechatr-JF-5227_2019.7aa0e4ce.jpg";